import React, { useState, useEffect , useRef } from 'react';
import { Toast } from 'primereact/toast';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar'; 
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
import { Card } from 'primereact/card';  
import { Fieldset } from 'primereact/fieldset';
import { format } from 'date-fns';
import { Calendar } from 'primereact/calendar';
import { getClientes } from '../api/clientesService';//getClientes
import { getMonedas,getFormasPago, getMediosPago} from '../api/monedaFormaPagoService';
import {getFacturasPorCliente }from '../api/facturaService'; 
import {addDocumentosPago ,getDocumentosPagoPorFactura}from '../api/pagosService'; 
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';


const Facturas = () => {
const toast = useRef(null);
const fetchIdRef = useRef(0); // <-- para evitar race conditions

const [clientes, setClientes] = useState([]);
const [cliente, setCliente] = useState(null); 
const [facturasCliente, setFacturasCliente] = useState([]); // 🔹 Facturas del cliente seleccionado
const [facturaSeleccionada, setFacturaSeleccionada] = useState(null); // 🔹 Factura seleccionada en el segundo dropdown

const [totalMonto, setTotalMonto] = useState(0);
const [lineasPago, setLineasPago] = useState([]); // 🔹 Filas que se mostrarán en el DataTable (una por factura “agregada”)
//const [date, setDate] = useState(null);  
const [date, setDate] = useState(new Date());

const [monedas, setMonedas] = useState([]);
const [moneda, setMoneda] = useState(null);
const [formaPagos, setFormasPagos] = useState([]);
const [formaPago, setFormasPago] = useState(null);

const [medioPagos, setMediosPagos] = useState([]);   
const [medioPago, setMediosPago] = useState(null);   

// Cargar clientes al inicio
useEffect(() => {
    // const fetchClientes = async () =>setClientes(await getClientes()) ;
    // fetchClientes();
     const fetchData = async () => 
        {
          const data = await getClientes();  
          const activas = data.filter(e => e.activo === true); // o e.estatus === "Activo"
          setClientes(activas); 
        };
       
      fetchData();
}, []);
// Cargar monedas al inicio
useEffect(() => {
    const fetchMonedas = async () =>setMonedas(await getMonedas()) ;
    fetchMonedas();
}, []);
// Cargar formas de pago al inicio
useEffect(() => {
    const fetchFormaPago = async () =>setFormasPagos(await getFormasPago()) ;
    fetchFormaPago();
}, []);

useEffect(() => {
    const fetchMedioPago = async () =>setMediosPagos(await getMediosPago()) ;
    fetchMedioPago();
}, []);

    
// Cuando cambia el cliente, traemos sus facturas
useEffect(() => {
  const load = async () => {
     // 1) limpiamos inmediatamente la UI/estados dependientes
    setFacturaSeleccionada(null); // 🔹 Reseteamos selección anterior
    setFacturasCliente([]);       // 🔹 Vaciamos dropdown antes de cargar nuevas facturas
    setLineasPago([]);            // 🔹 Reseteamos DataTable
    // 2) si no hay cliente, terminamos
    if (!cliente || !cliente.ruc) return;
    // 3) control de race: incrementamos id de esta petición
    const id = ++fetchIdRef.current;

    try {
      const facturas = await getFacturasPorCliente(cliente.ruc);
      // 4) aplicamos resultados solo si sigue siendo la petición más reciente
      if (fetchIdRef.current === id) {
        setFacturasCliente(facturas || []);
      }
    } catch (err) {
      console.error('Error cargando facturas del cliente:', err);
      // opcional: mostrar toast de error
    }
  };
    load ();
}, [cliente]);  

useEffect(() => {
    const total = lineasPago.reduce((acc, linea) => acc + (linea.monto || 0), 0);
    setTotalMonto(total);
}, [lineasPago]);

const formatFecha = (rowData) => {
  if (!rowData.fechaEmision) return '';
  return format(new Date(rowData.fechaEmision), 'dd-MM-yyyy');
};
// 🔹 Agrega una factura al DataTable calculando saldo y parcialidad
const agregarFacturaAlPago = async (factura) => {
  if (!factura?._id) return;

  const pagos = await getDocumentosPagoPorFactura(factura._id);
  console.log(JSON.stringify(pagos, null, 2));
  const totalPagado = pagos.reduce((acc, p) => {
    // Recorrer cada documento y filtrar solo los datosDocumento que coinciden  
    const sumaPorDocumento = p.datosDocumento
    .filter(doc => doc.idDocumento === factura._id) // Solo los de la factura actual
    .reduce((sum, doc) => sum + Number(doc.saldoPagado || 0), 0);

    return acc +sumaPorDocumento;
  },0);
  console.log(totalPagado);
  const saldoPendiente = Math.max(0, Number(factura.totalPagar || 0) - totalPagado).toFixed(2);
  const parcialidadSiguiente = (pagos
  .reduce((acc, pago) => {
    return acc + pago.datosDocumento.filter(doc => doc.idDocumento === factura._id).length;
  }, 0)) + 1;

  const fila = {
    _id: factura._id,// dataKey
    serie: factura.serie,
    folio: factura.folio,
    fechaEmision:factura.fechaEmision,
    total: Number(factura.totalPagar || 0),
    saldo: saldoPendiente,      // ← calculado
    parcialidad: parcialidadSiguiente, // ← #pagos + 1
    monto: null,                // ← editable por el usuario
  };
// Evita duplicados por _id
  setLineasPago((prev) => {
    const existe = prev.some((r) => r._id === fila._id);
    return existe ? prev.map((r) => (r._id === fila._id ? fila : r)) : [...prev, fila];
  });

  toast.current?.show({
    severity: 'info',
    summary: 'Registro agregado',
    position:'bottom-right',
    detail: `Factura: ${fila.serie} - ${fila.folio}. \nSaldo: $${fila.saldo}`,
    life: 2500,
  });
};
const generarPagos = async () => {
  try {
    if (lineasPago.length === 0 ) {
      toast.current?.show({
        severity: 'warn',
        summary: 'Atención',
        detail: 'No hay pagos para guardar',
        life: 3000
      });
      return;
    }
     const usuario = localStorage.getItem("usuario") || "admin";
 // ✅ Formateamos fecha yyyy/MM/dd
    const fechaFormateada = date ? format(date, 'yyyy/MM/dd') : format(new Date(), 'yyyy/MM/dd');

    // Preparamos la data con la estructura solicitada
    const pagos =  {
      datosDocumento: lineasPago.map((p)  => ({
        ruc: cliente?.ruc || '',
        idDocumento: p._id,
        serie: p.serie,
        folio: p.folio,
        numeroParcialidad: p.parcialidad,
        saldoAnterior: p.saldo,
        saldoPagado: p.monto || 0
      })),
      moneda: moneda,                      // Puedes cambiarlo si quieres que venga de un dropdown
      formaPago: formaPago,        // Igual, puedes hacerlo dinámico si lo necesitas
      fechaPago: fechaFormateada,
      totalPagado:  lineasPago.reduce((acc, linea) => acc + (linea.monto || 0), 0),
      status: "ACTIVO",               // O "PAGADO" según la lógica de negocio
      created_at: new Date(),
      usuario: usuario 
    };

    // Guardamos en MongoDB
    await addDocumentosPago(pagos);

    toast.current?.show({
      severity: 'success',
      summary: 'Éxito',
      detail: 'Pagos guardados correctamente',
      life: 3000
    });

    // Limpiamos los estados
    setLineasPago([]);
    setFacturaSeleccionada(null);
    setTotalMonto(0);
  } catch (error) {
    toast.current?.show({
      severity: 'error',
      summary: 'Error',
      detail: 'Ocurrió un error al guardar los pagos',
      life: 4000
    });
  }
};


const eliminarFactura = (factura) => {
  console.log('ele');
  confirmDialog({
    message: `¿Seguro que deseas eliminar la factura ${factura.serie}-${factura.folio} de la lista?`,
    header: 'Eliminar registro',
    icon: 'pi pi-exclamation-triangle',
    acceptLabel: 'Sí, eliminar',
    rejectLabel: 'Cancelar',
    acceptClassName: 'p-button-danger',
    rejectClassName: 'p-button-secondary',
    accept: () => {

  setLineasPago((prev) => prev.filter((f) => f._id !== factura._id));
   toast.current?.show({
        severity: 'success',
        summary: 'Eliminado',
        detail: 'Registro eliminado correctamente',
        life: 3000,
      });
    },
    reject: () => {
      toast.current?.show({
        severity: 'info',
        summary: 'Cancelado',
        detail: 'No se eliminó el registro',
        life: 2000,
      });
    },
  });
};

return (   
<>
<Toast ref={toast} />
<ConfirmDialog />
  <section className="mission-section" id="pagosFacturas">
  <div class="layout-content-inner">
    <div>
      <nav class="layout-breadcrumb">
        <ol>
          <li><a href="/"><i class="pi pi-home"></i></a></li>
          <li class="layout-breadcrumb-chevron"> / </li>
          <li>Pagos de facturas</li>
        </ol>
      </nav>
    </div>

    <Card title="Pagos"></Card>
    <h5></h5>   
    
    <div className="formgrid grid">
      <div className="field col-8">
        <div className="card">
          <Fieldset legend="Datos del Cliente">
            {/* Dropdown de Clientes */}
            <Dropdown value={cliente}  
              onChange={(e) => setCliente(e.value)}  
              options={clientes}   
              placeholder="Selecciona un cliente" optionLabel="razonSocial" className="w-full md:w-40rem"
              itemTemplate={(option) => `${option.ruc} - ${option.razonSocial}`}
              valueTemplate={(option, props) => option ? `${option.ruc} - ${option.razonSocial}` : props.placeholder}/>
            
            <h5>Facturas</h5>
            {/* Dropdown de Facturas */}
            <Dropdown value={facturaSeleccionada} 
              key={cliente ? cliente.ruc : 'none'} // force remount cuando cambia el cliente (claro y efectivo)
              onChange={(e) =>  setFacturaSeleccionada(e.value)}  
              options={facturasCliente} disabled={!cliente}
              placeholder="Selecciona un factura" optionLabel="folio" className="w-full md:w-30rem"  dataKey="_id" emptyMessage="Este cliente no cuenta con facturas"
              itemTemplate={(option) => `${option.serie} - ${option.folio}`}
              valueTemplate={(option, props) => option ? `${option.serie} - ${option.folio}` : props.placeholder}/>
            
            <Button label="Agregar" icon="pi pi-plus" disabled={!facturaSeleccionada}
              onClick={() => agregarFacturaAlPago(facturaSeleccionada)}/>
          </Fieldset>                    
        </div>{/* fin de div className="card" */}
      </div>{/* fin de div className="field col-8" */}
      <div className="field col-4">
        <div className="card">
          <Fieldset legend="Fecha de pago">
             <Calendar value={date}    onChange={(e) => setDate(e.value)}   dateFormat="dd/mm/yy"  showIcon   />
          </Fieldset>
        </div>{/* fin de div className="card" */}
      </div>{/* fin de div cclassName="field col-4" */}
    </div>{/* fin de div className="formgrid grid" */}
    
    <Fieldset legend="Pagos">
      <Toolbar className="mb-4" ></Toolbar>     
      <DataTable value={lineasPago} dataKey="_id" responsiveLayout="scroll" >
        <Column field="serie" header="Serie" />
        <Column field="folio" header="Folio" />
        <Column field="fechaEmision" header="Fecha"  body={formatFecha} />
        <Column field="total" header="Total"/>
        <Column field="saldo" header="Saldo"/>
        {/* 🔹 Parcialidad con input fijo */}
        <Column field="parcialidad" header="Parc." 
          body={(rowData) => ( <InputNumber value={rowData.parcialidad}
          onValueChange={(e) => setLineasPago((prev) =>  prev.map((r) =>  r._id === rowData._id ? { ...r, parcialidad: e.value } : r  ))}
          min={1}
          mode="decimal"
          useGrouping={false}/>)} />
              
        <Column field="monto" header="Monto" 
          body= {(rowData)=>(  <InputNumber value={rowData.monto ?? rowData.saldo ?? 0}  // usa saldo si monto no existe    
          onValueChange={(e) =>  setLineasPago((prev) =>  prev.map((r) =>  r._id === rowData._id ? { ...r, monto: e.value } : r  )) }
          min={0}
          max={rowData?.saldo ?? undefined}
          mode="decimal"
          useGrouping={false}
          placeholder="0.00" />)} />
        
        <Column  header="Acciones"  
          body={(rowData) => (<Button icon="pi pi-times" severity="danger" aria-label="Cancel" onClick={() => eliminarFactura(rowData)} /> )}/> 
      </DataTable>
    </Fieldset>

    <div className="formgrid grid">
      <div className="field col">
        <Fieldset legend="Medios de pago">
          <Dropdown id="idMediosPago" value={medioPago} 
          onChange={(e) => setMediosPago(e.value)} options={medioPagos}
          placeholder="Seleccione " className="w-full md:w-300rem" optionLabel="name" 
          itemTemplate={(option) => `${option.numero} - ${option.nombre}`} 
          valueTemplate={(option, props) => option ? `${option.numero} - ${option.nombre}` : props.placeholder}  />
        </Fieldset>
      </div>
      <div className="field col">
        <Fieldset legend="Moneda de pago">
          <Dropdown id="idMoneda" value={moneda} 
            onChange={(e)=>setMoneda(e.value)} 
            options={monedas}
            placeholder="Seleccione " className="w-full md:w-300rem" optionLabel="name"  
            itemTemplate={(option) => `${option.codigo} - ${option.moneda}`} 
            valueTemplate={(option, props) => option ? `${option.codigo} - ${option.moneda}` : props.placeholder}/> 
          
          {/* <h6>Forma de pago</h6>
          <Dropdown id="idFormatoPago" value={formaPago} 
            onChange={(e)=>setFormasPago(e.value)} 
            options={formaPagos}
            placeholder="Seleccione " className="w-full md:w-300rem" optionLabel="name"
            itemTemplate={(option) => `${option.numero} - ${option.nombre}`} 
            valueTemplate={(option, props) => option ? `${option.numero} - ${option.nombre}` : props.placeholder}  />  */}
        </Fieldset>
      </div>
      
      <div className="field col">
        <Fieldset legend="Montos">
          <h5 className="mt-4">TOTAL: $ {totalMonto}</h5>
            
          <Button label="Guardar pago" icon="pi pi-check"  severity="info" raised    onClick={generarPagos} />
        </Fieldset>
      </div>{/* fin de div className="field col" */}                
    </div>{/* fin de div className="formgrid grid" */}
  </div>{/* fin de div class="layout-content-inner" */}
  </section>{/* fin de section className="mission-section" id="pagosFacturas" */}
   
 </>
  );
};

export default Facturas;
